import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api.js';
import { qk } from '@/lib/queryKeys.js';
import { Select } from '@/components/ui/Select.jsx';

export function EmployeePicker({ value, onChange, includeBlank = true, ...props }) {
  const { data = [] } = useQuery({
    queryKey: qk.employees({ status: 'active' }),
    queryFn: () => api.get('/employees?status=active'),
  });
  return (
    <Select value={value ?? ''} onChange={(e) => onChange?.(e.target.value ? Number(e.target.value) : null)} {...props}>
      {includeBlank && <option value="">— Select employee —</option>}
      {data.map((e) => (
        <option key={e.id} value={e.id}>
          {e.emp_no} — {e.full_name}
        </option>
      ))}
    </Select>
  );
}
